import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { login } from '../api/auth';

export default function LoginPage() {
    const [user, setUser] = useState('');
    const [password, setPassword] = useState('');
    const [busy, setBusy] = useState(false);

    const params = new URLSearchParams(useLocation().search);
    const redirect = params.get('redirect') || '/';

    async function onSubmit(e) {
        e.preventDefault();
        if (!user || !password) return toast.error('Vui lòng nhập đủ tài khoản và mật khẩu');
        try {
            setBusy(true);
            await login({ user: user.trim(), password });
            toast.success('Đăng nhập thành công');
            window.location.replace(redirect); // không đụng router context
        } catch {
            toast.error('Sai tài khoản hoặc mật khẩu');
        } finally {
            setBusy(false);
        }
    }

    return (
        <form onSubmit={onSubmit} className="max-w-sm mx-auto p-4 grid gap-3">
            <input className="p-3 border rounded-xl" placeholder="Tài khoản" value={user} onChange={e => setUser(e.target.value)} />
            <input className="p-3 border rounded-xl" placeholder="Mật khẩu" type="password" value={password} onChange={e => setPassword(e.target.value)} />
            <button disabled={busy} className="p-3 rounded-xl bg-red-600 text-white disabled:opacity-60">
                {busy ? 'Đang đăng nhập...' : 'Đăng nhập'}
            </button>
        </form>
    );
}
